const apiVersion = `4.4`;
export const apiPath = `/api/v${apiVersion}`;

export const apiEndpoint = {
  user: `${apiPath}/users`,
  mycommunities: `${apiPath}/communities/my`,
  contents: `${apiPath}/contents`,
  translation: `${apiPath}/translations/comments`,
  searches: `${apiPath}/searches`,
  idpEndpoint: '/o_auth_tokens.json?provider=auth0'
};

const contentCommunitiesEndpoint = (contentId) => {
  return `${apiEndpoint.contents}/${contentId}/communities/my`;
};

const userEndpoint = () => {
  return `${apiEndpoint.user}/me`;
};

const commentsEndpoint = (contentId) => {
  return `${apiEndpoint.contents}/${contentId}/comments`;
};

const likeCommentEndpoint = (contentId, commentId) => {
  const comments = commentsEndpoint(contentId);
  return `${comments}/${commentId}/like`;
};

const complaintCommentEndpoint = (contentId, commentId) => {
  const comments = commentsEndpoint(contentId);
  return `${comments}/${commentId}/complaint`;
};

const postCommentEndpoint = (contentId) => {
  const comments = commentsEndpoint(contentId);
  return comments;
};

const deleteOrEditCommentEndpoint = (contentId, commentId) => {
  return `${commentsEndpoint(contentId)}/${commentId}`;
};

const parentCommentsEndpoint = (contentId) => {
  return `${commentsEndpoint(contentId)}/roots`;
};

const childrenCommentsEndpoint = (contentId, parentId) => {
  return `${commentsEndpoint(contentId)}/${parentId}/descendants`;
};

const translateCommentEndpoint = (commentId) => {
  return `${apiEndpoint.translation}/${commentId}`;
};

const mentionableUsersEndpoint = () => {
  return `${apiEndpoint.searches}/mentionable/users`;
};

const contentsEnpoint = (contentId) => {
  return `${apiEndpoint.contents}/${contentId}`;
};

const topicContentEndpoint = () => {
  return `${apiPath}/topic_contents/`;
};

export {
  userEndpoint,
  commentsEndpoint,
  complaintCommentEndpoint,
  likeCommentEndpoint,
  postCommentEndpoint,
  deleteOrEditCommentEndpoint,
  parentCommentsEndpoint,
  childrenCommentsEndpoint,
  translateCommentEndpoint,
  mentionableUsersEndpoint,
  contentsEnpoint,
  topicContentEndpoint,
  contentCommunitiesEndpoint,
  apiEndpoint as default
};
